import * as constants from '@/constants'

export const getDisplayReturnOptions = allowedTransactionTypes =>
  allowedTransactionTypes?.includes(constants.allowedTransactionTypes.exchange) &&
  (allowedTransactionTypes?.includes(constants.allowedTransactionTypes.instantRefund) ||
    allowedTransactionTypes?.includes(constants.allowedTransactionTypes.originalPaymentMethod))
